import { render, staticRenderFns } from "./ProductEditTabGalery.vue?vue&type=template&id=03112ef1&"
import script from "./ProductEditTabGalery.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabGalery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports